<template>
  <div :id="id" class="cat-repeater-child-detail">
    <cat-box :id="id" :label="heading" :help="help">
      <slot></slot>
      <div class="repeater-detail-buttons buttons text-align-right">
        <slot name="detail-buttons">
          <cat-btn
            v-if="allowCancel"
            class="edit-item mlt pn"
            :button-tag="true"
            :small="true"
            :simple="true"
            :link="true"
            :label="cancelLabel"
            @ui-click="handleCancel"
          />
          <cat-btn
            v-if="allowDone"
            class="edit-item mll"
            :button-tag="true"
            :small="true"
            :primary="true"
            :label="doneLabel"
            @ui-click="handleDone"
          />
          <cat-btn
            v-if="allowDelete && selected"
            :class="deleteClasses"
            :icon="selected ? null : 'trash'"
            :button-tag="true"
            :small="true"
            :link="!selected"
            :secondary="selected"
            :label="deleteLabel"
            @ui-click="handleDelete"
          />
          <cat-btn
            v-if="!allowDone"
            class="edit-item mlt pn"
            :button-tag="true"
            :small="true"
            :simple="true"
            :link="true"
            :label="hideLabel"
            @ui-click="handleDone"
          />
        </slot>
      </div>
      <div class="details"><slot name="details"></slot></div>
    </cat-box>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatBtn from "@/components/catBtn/catBtn.vue";
import CatBox from "@/components/catBox/catBox.vue";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatRepeaterChildDetail",
  components: { CatBtn, CatBox },
  props: {
    id: {
      type: [String, Number],
      description: "Repeater child detail ID."
    },
    selected: {
      type: Boolean,
      description: "Zero-based index of the currently selected record."
    },
    editable: {
      type: Boolean,
      description: "Not in use."
    },
    allowEdit: {
      type: Boolean,
      default: true,
      description: "Not in use."
    },
    allowDelete: {
      type: Boolean,
      default: true,
      description: "Renders 'Delete' button if true."
    },
    allowView: {
      type: Boolean,
      default: false,
      description: "Not in use."
    },
    allowDone: {
      type: Boolean,
      default: false,
      description: "Renders 'Done' button if true."
    },
    allowCancel: {
      type: Boolean,
      default: false,
      description: "Renders 'Cancel' button if true."
    },
    editButtonLabel: {
      type: String,
      default: "Edit",
      description: "Not in use."
    },
    deleteButtonLabel: {
      type: String,
      default: "Delete",
      description: "Specifies 'Delete' button label."
    },
    cancelButtonLabel: {
      type: String,
      default: "Cancel",
      description: "Specifies 'Cancel' button label."
    },
    doneButtonLabel: {
      type: String,
      default: "Done",
      description: "Specifies 'Cancel' button label."
    },
    viewButtonLabel: {
      type: String,
      default: "View",
      description: "Not in use."
    },
    hideButtonLabel: {
      type: String,
      description: "Hides button label and renders 'Show less' as label."
    },
    showDetails: {
      type: Boolean,
      default: false,
      description: "Not in use."
    },
    help: {
      type: Object,
      description: "Help details for this repeater child detail."
    },
    heading: {
      type: String,
      default: "Details",
      description:
        "Heading text displayed at the top of the child detail section."
    }
  },

  computed: {
    deleteClasses: function () {
      return this.selected ? ["edit-item", "mlt"] : ["edit-item", "pn", "mlt"];
    },
    deleteLabel: function () {
      return (
        this.deleteButtonLabel || this.resolveTxt("repeater.delete", "Delete")
      );
    },
    doneLabel: function () {
      return (
        this.doneButtonLabel || this.resolveTxt("skin.default.done", "Done")
      );
    },
    hideLabel: function () {
      return (
        this.hideButtonLabel ||
        this.resolveTxt("repeater.show.less", "Show less")
      );
    },
    cancelLabel: function () {
      return (
        this.cancelButtonLabel || this.resolveTxt("repeater.cancel", "Cancel")
      );
    }
  },

  methods: {
    handleDelete: function (event) {
      this.$emit("ui-repeater-delete", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleEdit: function (event) {
      this.$emit("ui-repeater-edit", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleView: function (event) {
      this.$emit("ui-repeater-view", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleDone: function (event) {
      this.$emit("ui-repeater-done", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleCancel: function (event) {
      this.$emit("ui-repeater-cancel", {
        event: event,
        id: this.id ? this.id : null
      });
    }
  }
});
</script>
